"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testFieldVisibilitySettings = void 0;
exports.testFieldVisibilitySettings = {
    containerId: "MyPane",
    app: "S",
    components: [
        {
            fieldName: "OrderNumber",
            sortOrder: 0,
            visible: true,
            required: true,
            editable: true,
            Id: 89
        },
        {
            fieldName: "ContractNumber",
            sortOrder: 1,
            visible: false,
            required: false,
            editable: true,
            Id: 90
        },
        {
            fieldName: "QuoteNumber",
            sortOrder: 2,
            visible: true,
            required: false,
            editable: false,
            Id: 91
        },
        {
            fieldName: "CustomerName",
            sortOrder: 3,
            visible: true,
            required: false,
            editable: false,
            Id: 88
        },
        {
            fieldName: "OrderTotal",
            sortOrder: 4,
            visible: false,
            required: false,
            editable: true,
            Id: 87
        },
        {
            fieldName: "InventoryNumber",
            sortOrder: 5,
            visible: false,
            required: false,
            editable: true,
            Id: 92
        },
        {
            fieldName: "CustomerNumber",
            sortOrder: 6,
            visible: true,
            required: false,
            editable: true,
            Id: 93
        }
    ]
};
//# sourceMappingURL=testFieldVisibilitySettings.js.map